import Confirm from '@/components/common/Confirm.vue';
import Fiat from '@/utils/fiat.js';
import RUC from '@/utils/Ruc';
import * as types from '@/store/mutation-types';
import {
    mapState,
} from 'vuex';
import Config from '@/utils/Config';
import Utils from '@/utils/Utils';

export default {
    name: 'Fiat',
    props: ['currTarget'],
    data() {
        return {
            confirmStatus: false,
            formItem: {
                channel: 'indacoin',
                address: '',
                amountIn: '',
                amountOut: 0,
                currency: 'USD',
                token: this.currTarget.asset,
                appid: '1',
            },
            computedPrice: false,
            modalSuccess: false,
            assets: null,
            userid: '',
            amountIn: [],
            amountOut: [],
            userId: '',
            currIndex: -1,
        };
    },
    computed: {
        ...mapState({
            storeConfirmStatus: state => state.confirmStatus,
        }),
        user() {
            return this.$store.state.user;
        },
    },
    watch: {
        'formItem.amountIn': function () {
            this.changeToken();
        },
    },
    components: {
        Confirm,
    },
    mounted() {
        const self = this;
        Fiat.getAmountList({ channel: 'indacoin' }).then((res) => {
            if (res.data.code === 0) {
                self.amountIn = res.data.amountIn;
                self.amountOut = res.data.amountOut;
            } else {
                self.$Message.error(self.$t('Error'));
            }
        }).catch((err) => {
            console.log(err, 'err');
        });
        let currUser = '';
        if (!Config.CenterTrade) {
            const AccountList = self.$store.state.accountList;
            const currAccountIndex = self.$store.state.currAccountIndex;
            currUser = AccountList[currAccountIndex].userid;
        } else {
            currUser = this.user.bttUserid;
        }
        const token = Utils.getQueryObject().token;

        const tokenInfo = Utils.getToken(token);
        if (tokenInfo.email) {
            self.formItem.currency = tokenInfo.currency;
            self.formItem.amountIn = tokenInfo.amount;
            if (tokenInfo.walletId) {
                self.formItem.address = tokenInfo.walletId;
            }
        }
        self.userid = currUser;
        RUC.getDepositAddress(self.userid).then((res) => {
            if (res.code === 2 || res.code === 0) {
                self.assets = res.data;
                localStorage.setItem('assetsInfo', JSON.stringify(res.data));
            }
        });
    },
    methods: {
        showDialog() {
            const self = this;
            if (
                self.withdraw.curr === '' ||
                self.withdraw.curr.amount === '' ||
                self.withdraw.curr.amount === 0
            ) {
                self.$Message.error(self.$t('balance_please_input_address_and_amount'));
            } else {
                self.confirmStatus = true;
                self.currIndex = self.$store.state.currAccountIndex;
                self.$store.commit(types.CHANGE_CONFIRMSTATUS, true);
            }
            self.$emit('tempHideDialog', 'close');
        },
        confirmAction(res) {
            const self = this;
            if (res.code === 0) {
                self.doWithDraw(res.password);
                self.confirmStatus = false;
                self.$emit('tempHideDialog', 'open');
            }
        },
        createTransaction() {
            const self = this;
            if (this.formItem.currency === '' || this.formItem.token === '' || this.formItem.amountIn === '') {
                return self.$Message.error('Not allow empty');
            }
            if (this.computedPrice === 0) {
                return self.$Message.error('wait for compute!');
            }
            if (parseFloat(self.formItem.amountIn) < parseFloat(self.currTarget.pixiu_min_deposit_amount)) {
                return self.$Message.error('The amount not allow less than min deposit amount!');
            }
            const chainType = this.amountOut.filter(item => item.id == self.currTarget.id)[0].chainType;
            if (this.formItem.address === '') {
                this.formItem.address = this.getAddress(chainType);
            }
            this.formItem.userid = this.userid;
            if (Config.CenterTrade) {
                this.formItem.email = this.user.email;
            }
            Fiat.createTransaction(this.formItem).then((res) => {
                if (res.data.code === 0) {
                    // const myWin = window.open();
                    self.modalSuccess = true;
                    window.location.href = res.data.payUrl;
                } else {
                    self.$Message.error(self.$t('Error'));
                }
            }).catch((err) => {
                console.log(err.response, 'err');
                if (err.response && err.response.data && err.response.data.code === 100011) {
                    return self.$Message.error('Min deposit amount is 50 USD ');
                }
                if (err.response && err.response.data && err.response.data.code === 100012) {
                    return self.$Message.error('too big amount');
                }
                return self.$Message.error(err.response.data.msg);
            });
        },
        ok() {
            this.$emit('withdrawhidden');

            this.$router.push('/History?type=fiat');
        },
        changeToken: Utils._debounce(function (type, $event) {
            const self = this;
            self.computedPrice = false;
            if (this.formItem.currency != '' && this.formItem.token != '' && this.formItem.amountIn != '') {
                Fiat.getCoinConvertAmount({
                    channel: 'indacoin',
                    currency: this.formItem.currency,
                    token: this.formItem.token,
                    amountIn: this.formItem.amountIn,
                }).then((res) => {
                    if (res.data.code === 0) {
                        self.formItem.amountOut = res.data.amountOut;
                        self.computedPrice = true;
                    } else {
                        self.$Message.error(self.$t('Error'));
                    }
                });
            }
        }, 300),

        getAddress(chainType) {
            const self = this;
            const addressType = {
                1: 'ethereum',
                2: 'bitcoin',
                3: 'cmt',
                4: 'naka',
                5: 'ltc',
                6: 'bch',
                7: 'bsv',
                8: 'doge',
                9: 'dash',

            };
            let assets = self.assets;
            if (!assets) {
                assets = JSON.parse(localStorage.getItem('assetsInfo'));
            }
            return assets[addressType[chainType]];
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/common/fiat.js